import {BASIC_MODAL_QUESTION} from "../../constants/store";

export const is_show_question = (state = false, action) => {
  switch (action.type) {
    case BASIC_MODAL_QUESTION:
      return action.payload;
    default:
      return state;
  }
};